import { SchedulingStore } from "@/Appointments/Stores/SchedulingStore";
import { SchedulingTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class SchedulingTabHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.SchedulingTab.SubTabSwitch, this.SubTabSwitch);
    }

    private SubTabSwitch(request: LocalEvent, store: SchedulingStore): void {
        var schedulingTabViews = request.Get<SchedulingTabViews>("value");
        store.SchedulingTabModel = store.SchedulingTabModel.set("CurrentView", schedulingTabViews);
    }
}

export { SchedulingTabHandler };
